import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import debounce from "lodash.debounce";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import Localization from "../../localization";
import Button from "../button";
import IconClose from "../icons/close";
import IconLogo from "../icons/logo";
import IconSpinner from "../icons/spinner";

import { changeSearch } from "../../redux/actions/options";
import { loadSearch } from "../../redux/actions/search";
import { getUrl } from "../../utils/helper";
import { DateTime } from "luxon";

class Search extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search: "",
        };

        this._onClose = this._onClose.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onSearchText = debounce(this._onSearch.bind(this), 500);
    }

    _onClose() {
        this.props.changeSearch(false);
        setTimeout(() => {
            this.setState({
                search: "",
            });
        }, 700);
    }

    _onChange(event) {
        this.setState(
            {
                search: event.target.value,
            },
            () => {
                this._onSearchText();
            }
        );
    }

    _onSearch() {
        const { search } = this.state;

        if (search !== "") this.props.loadSearch(true, search);
    }

    _renderPosts() {
        const { data, locale } = this.props;

        if (data.posts.length === 0) return null;

        return (
            <div className="xl:flex-1 xl:mr-50">
                <p className="font-judge text-17 text-orange mb-16">
                    {Localization[locale].home.search_articles}
                </p>
                <div className="flex flex-col mb-32">
                    {data.posts.map((item) => (
                        <Link
                            to={getUrl(
                                "bookmarks/" + item.tag.slug + "/" + item.slug
                            )}
                            onClick={this._onClose}
                            className="text-white mb-8"
                            title={item.title}
                        >
                            {item.title}
                        </Link>
                    ))}
                </div>
            </div>
        );
    }

    _renderArtists() {
        const { data, locale } = this.props;

        if (data.artists.length === 0) return null;

        return (
            <div className="xl:flex-1">
                <p className="font-judge text-17 text-orange mb-16">
                    {Localization[locale].home.search_artists}
                </p>
                <div className="flex flex-col mb-32">
                    {data.artists.map((item) => (
                        <Link
                            to={getUrl("artists/" + item.slug)}
                            onClick={this._onClose}
                            className="text-white mb-8"
                            title={item.name}
                        >
                            {item.name}
                        </Link>
                    ))}
                </div>
            </div>
        );
    }

    _renderLessons() {
        const { data, locale } = this.props;

        if (data.lessons.length === 0) return null;

        return (
            <div className="xl:flex-1">
                <p className="font-judge text-17 text-orange mb-16">
                    {Localization[locale].home.search_lessons}
                </p>
                <div className="flex flex-col mb-32">
                    {data.lessons.map((item) => {
                        let lessonDate = DateTime.fromISO(item.date);

                        return (
                            <Link
                                to={getUrl(
                                    "practices/" + lessonDate.toISODate()
                                )}
                                onClick={this._onClose}
                                className="text-white mb-8"
                                title={item.name}
                            >
                                {item.name +
                                    " (" +
                                    lessonDate
                                        .toLocaleString({ dateStyle: "short" })
                                        .split("/")
                                        .join(".") +
                                    ")"}
                            </Link>
                        );
                    })}
                </div>
            </div>
        );
    }

    _renderOpenCalls() {
        const { data, locale } = this.props;

        if (data.open_calls.length === 0) return null;

        return (
            <div className="xl:flex-1">
                <p className="font-judge text-17 text-orange mb-16">
                    {Localization[locale].home.search_open_calls}
                </p>
                <div className="flex flex-col mb-32">
                    {data.open_calls.map((item) => (
                        <Link
                            to={getUrl("opencalls/" + item.type)}
                            onClick={this._onClose}
                            className="text-white mb-8"
                            title={item.title}
                        >
                            {item.title}
                        </Link>
                    ))}
                </div>
            </div>
        );
    }

    _renderResults() {
        const { data, locale, isLoading } = this.props;
        const { search } = this.state;

        if (search !== "") {
            if (isLoading)
                return (
                    <div className="flex justify-center mt-40">
                        <IconSpinner className="animate-spin w-20 xl:w-32 h-20 xl:h-32 text-orange" />
                    </div>
                );

            if (
                data &&
                (data.posts.length > 0 ||
                    data.artists.length > 0 ||
                    data.open_calls.length > 0 ||
                    data.lessons.length > 0)
            )
                return (
                    <div className="flex flex-col xl:flex-row mt-40">
                        {this._renderPosts()}
                        {this._renderArtists()}
                        {this._renderLessons()}
                        {this._renderOpenCalls()}
                    </div>
                );

            if (data)
                return (
                    <div className="flex justify-center mt-40">
                        <p className="text-white mb-8">
                            {Localization[locale].home.search_empty}
                        </p>
                    </div>
                );
        }

        return null;
    }

    render() {
        const { visible, locale } = this.props;
        const { search } = this.state;

        let className =
            "fixed z-40 inset-0 overflow-y-auto bg-blue transition duration-300 ease-in-out";
        if (!visible) {
            className += " pointer-events-none opacity-0";
        }

        return (
            <div className={className}>
                <Helmet>{visible && <body className="modal-open" />}</Helmet>
                <div className="flex flex-col px-16 xl:px-50 pt-30 xl:pt-40 pb-60">
                    <div className="flex">
                        <div className="flex justify-between">
                            <div className="flex flex-col">
                                <IconLogo
                                    className={
                                        "w-140 xl:w-208 h-30 -ml-2 xl:ml-0 xl:h-46 text-orange"
                                    }
                                />
                                <p
                                    className={
                                        "font-judge font-bold mt-5 xl:mt-8 text-12 xl:text-17 text-orange"
                                    }
                                >
                                    PAULO CUNHA E SILVA
                                </p>
                            </div>
                        </div>
                        <div className="flex-1 xl:hidden" />
                        <div className="hidden xl:flex items-center flex-1 mx-120">
                            <input
                                type="text"
                                value={search}
                                onChange={this._onChange}
                                placeholder={Localization[locale].home.search}
                                className="transition px-0 placeholder-white placeholder-opacity-20 bg-blue text-white text-17 xl:text-23 font-bold border-0 border-b border-white border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-white block w-full"
                            />
                        </div>
                        <div className="flex items-center">
                            <Button
                                icon={
                                    <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-blue text-orange" />
                                }
                                backgroundColor={"bg-blue"}
                                backgroundColorOver={"bg-orange"}
                                borderColor={"border-orange"}
                                onClick={this._onClose}
                                style={"w-50 xl:w-70"}
                            />
                        </div>
                    </div>
                    <div className="xl:hidden mt-60">
                        <input
                            type="text"
                            value={search}
                            onChange={this._onChange}
                            placeholder={Localization[locale].home.search}
                            className="transition px-0 placeholder-white placeholder-opacity-20 bg-blue text-white text-17 xl:text-23 font-bold border-0 border-b border-white border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-white block w-full"
                        />
                    </div>
                    {this._renderResults()}
                </div>
            </div>
        );
    }
}

Search.defaultProps = {};

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    visible: state.options.isSearchVisible,
    isLoading: state.search.isLoading,
    data: state.search.data,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            loadSearch,
            changeSearch,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);
